import { Controller } from "@hotwired/stimulus"

// IANA → Rails (ActiveSupport) zone names for sensible defaults.
const TZ_MAP = {
  "America/New_York": "Eastern Time (US & Canada)",
  "America/Detroit": "Eastern Time (US & Canada)",
  "America/Chicago": "Central Time (US & Canada)",
  "America/Denver": "Mountain Time (US & Canada)",
  "America/Boise": "Mountain Time (US & Canada)",
  "America/Phoenix": "Arizona",
  "America/Los_Angeles": "Pacific Time (US & Canada)",
  "America/Anchorage": "Alaska",
  "Pacific/Honolulu": "Hawaii"
}

/**
 * Pre-selects a timezone <select> to match the user's current location
 * (browser timezone), so the project timezone defaults sensibly. Editable —
 * only fills when nothing is selected yet.
 */
export default class extends Controller {
  connect() {
    if (this.element.value) return
    try {
      const rails = TZ_MAP[Intl.DateTimeFormat().resolvedOptions().timeZone]
      if (rails && Array.from(this.element.options).some((o) => o.value === rails)) {
        this.element.value = rails
      }
    } catch (_) { /* leave on "Select…" */ }
  }
}
